
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-sort-numeric-up-alt fa-w-14",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"7.5","height":"15","data-prefix":"fas","data-icon":"sort-numeric-up-alt","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 248 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M107.31 36.69a16 16 0 00-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0016 16h32a16 16 0 0016-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"}})])
          )
        }
      }
    